import script from "./PortfolioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__